import { apiUrl } from "utils/urls";

import axios from "axios";

export const listReviewThread = async (reference_file_uuid) => {
    const { data } = await axios.get(apiUrl("review") + `/${reference_file_uuid}/thread`);
    return data;
};
